module.exports = __webpack_public_path__ + "media/images/donation/logo-etc-30e6c2135294f3a114f91285981938a0.jpg";